<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="5"></titled>
    <span class="apphome">
      <div class="box">
        <el-form :model="temp" ref="temp" label-width="120px" class="demo-temp" :rules="rules">
          <el-form-item label="额定电流:" prop="ratedCurrent">
            <el-input v-model="temp.ratedCurrent" style="width: 220px;"></el-input>
          </el-form-item>
          <el-form-item label="设备启用时间:" prop="startupTime">
            <el-date-picker v-model="temp.startupTime" type="date" placeholder="选择日期" value-format="timestamp" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit" :loading="flag">提 交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <el-tabs v-model="activeName" type="border-card" style="width: 100%;" @tab-click="handleClick">
        <el-tab-pane label="设置" name="first">
          <el-table :data="tableData"
            :header-cell-style="{color:'#4CA5FF',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:900,backgroundColor:'#fff'}"
            style="width: 97%;margin-left: 20px;">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column prop="date" label="设备ID" width="180" />
            <el-table-column prop="name" label="功能" width="90" />
            <el-table-column prop="address" label="安装日期" />
            <el-table-column prop="address" label="一次电压" width="140" />
            <el-table-column prop="address" label="环境预设" />
          </el-table>


          <div class="content">
            <div class="btn">
              <el-button type="primary" size="mine">管理环境数据</el-button>
              <el-button size="mine">编辑<i class="el-icon-edit"></i></el-button>
            </div>
            <div class="tit">设备信息</div>
            <div class="ul">
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
            </div>
            <div class="tit">设备信息</div>
            <div class="ul">
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
            </div>
            <div class="tit">设备信息</div>
            <div class="ul">
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
              <div class="li">
                <div class="n">断路器标签名称</div>
                <div class="t"></div>
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane label="警报条件" name="second">
          <span class="box">
            <div class="title">
              <div class="name">设备警报条件</div>
              <div class="right">
                <i class="el-icon-collection"></i>
                <el-button type="primary" size="mini" @click="dialogVisible = true">新建</el-button>
              </div>
            </div>
            <el-switch style="margin-left: 27px;margin-bottom: 10px;" v-model="value1" active-text="禁用设备的所有条件"
              inactive-text=""></el-switch>
            <el-table :data="tableData"
              :header-cell-style="{color:'#4CA5FF',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:900,backgroundColor:'#fff'}"
              style="width: 97%;margin-left: 30px;">
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column prop="date" sortable label="截止日期" width="140" />
              <el-table-column prop="name" label="优先" width="90" />
              <el-table-column prop="address" label="描述" />
              <el-table-column prop="address" label="用户" width="140" />
              <el-table-column prop="address" label="状态" />
              <el-table-column prop="date" label="执行日期" />
              <el-table-column prop="12" label="创建人" />
              <el-table-column prop="12" label="备注" />
            </el-table>
          </span>
        </el-tab-pane>
        <el-tab-pane label="连接状态" name="three">
          <div class="box">
            <div class="left">
              <img class="img" src="" alt="">
              <div class="img_txt">
                <div class="p">
                  <div class="nn">1AT1-TRAFO INCOMING</div>
                  <div class="t">ABB-E6-H40</div>
                </div>
                <div class="p">
                  <div class="n">1AT1-TRAFO INCOMING(SN BH 123456)</div>
                  <div class="t">已连接 <i class="el-icon-paperclip"></i></div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs> -->
    </span>

    <!-- 新增修改 -->
    <!-- <el-dialog title="新建" :close-on-click-modal='false' :visible.sync="dialogVisible" width="400" center>
      <el-form label-width="120px" class="demo-temp" >
        <el-form-item label="截止日期:" prop="Name">
          <el-date-picker v-model="temp.time" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="优先:">
          <el-radio v-model="temp.State" label="1">是</el-radio>
          <el-radio v-model="temp.State" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="描述:" prop="Name">
          <el-input v-model="temp.Name"></el-input>
        </el-form-item>
        <el-form-item label="用户:" prop="Name">
          <el-input v-model="temp.Name"></el-input>
        </el-form-item>
        <el-form-item label="状态:" prop="Name">
          <el-select v-model="temp.status" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="执行日期:" prop="Name">
          <el-date-picker v-model="temp.time2" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="创建人:" prop="Name">
          <el-input v-model="temp.Name"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Name">
          <el-input v-model="temp.Name"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary">确 定</el-button>
        </span>
      </template>
    </el-dialog> -->
  </div>
</template>
<script>
  import titled from '@/components/module/titled/titled.vue';
  import request from "@/api/http.js";
  export default {
    components: {
      titled,
    },
    data () {
      return {
        flag: false,
        rules: {
          ratedCurrent: [
            {required: true,message: '请输入额定电流',trigger: 'blur'},
          ],
          startupTime: [
            {required: true,message: '请选择设备启用时间',trigger: 'blur'},
          ],
        },
        nowDevice: '',
        dialogVisible: false,//弹窗
        temp: {},//弹窗数据
        value1: false,
        tableData: [],
        activeName: 'first',
        options: [{
          value: '1',
          label: '今年'
        },{
          value: '2',
          label: '今天'
        },{
          value: '3',
          label: '昨天'
        }],
        value: ''
      }
    },
    computed: {
      setDeviceItem () {
        return this.$store.cacheStore.state.setDevice
      },
    },
    watch: {
      setDeviceItem: function(val) {
        this.nowDevice=val;
        this.temp={}
        this.getList(val)
      },

    },
    mounted () {
      this.getList(this.setDeviceItem)
    },
    methods: {
      getList (val) {
        var params={
          "deviceNo": val.deviceNo,
        }
        this.flag=true;
        request({url: "/health/findByDeviceNoHealthDegree",method: "post",params}).then(res => {
          this.flag=false;
          if(res.code==200) {
            if(res.data.length) {
              this.temp={
                ratedCurrent: res.data[0],
                startupTime: res.data[1],
              }
            }
          }
        })
      },
      submit () {
        this.$refs.temp.validate((valid) => {
          if(valid) {
            var data={
              "deviceNo": this.setDeviceItem.deviceNo,
              "ratedCurrent": this.temp.ratedCurrent,
              "startupTime": this.temp.startupTime
            }
            request({url: "/health/configuration",method: "post",data}).then(res => {
              console.log(res);
              if(res.code==200) {
                this.$message({showClose: true,message: '保存成功',type: 'success'});
              }
            })
          }

        })

      },
      handleClick (tab,event) {

      }


    }
  };
</script>

<style lang="scss" scoped>
  .apphome .ul .li .n {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    color: #999;
  }

  .apphome .content {
    margin-left: .3rem;
  }

  .apphome .ul {
    font-size: .16rem;
    display: flex;
    flex-wrap: wrap;
  }

  .apphome .ul .li {
    width: 40%;
    display: flex;
    justify-content: space-between;
    margin-right: .4rem;
    margin-bottom: .2rem;
  }

  .apphome .tit {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: .18rem;
    line-height: 30px;
    color: #4CA5FF;
    margin-top: 0.3rem;
    margin-bottom: .15rem;
  }

  .apphome .btn {
    margin-top: .3rem;
  }

  .apphome .echart {
    width: 100%;
  }

  .apphome .search {
    display: flex;
  }

  .apphome .search .name {
    height: 30px;
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    color: #999;
    margin-bottom: 5px;
  }

  .apphome {
    padding: 15px;
    margin-top: 1rem;
    background-color: #fff;
  }

  .box .title .right {
    margin-left: auto;
  }

  .box .title .right i {
    color: #4CA5FF;
    font-size: .34rem;
    margin-right: 0.2rem;
    transform: translateY(4px);
  }

  .box .title .name {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: .2rem;
    line-height: .3rem;
    color: #4CA5FF;
  }

  .box .title {
    display: flex;
    align-items: center;
    padding: 0 .4rem 0 .4rem;
  }

  .apphome {
    padding: 15px;
    overflow-x: scroll;
    display: flex;
    margin-top: 1rem;
  }

  .apphome .box {
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 240px);
  }


  .box .left {
    display: flex;
  }

  .box .img {
    width: .64rem;
    height: .62rem;
    background: #FF7474;
    border-radius: .08rem;
    margin-left: .45rem;
    margin-right: .12rem;
  }

  .box .img_txt .p {
    display: flex;
  }

  .box .img_txt {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .box .img_txt .p .nn {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: .2rem;
    line-height: .24rem;
    color: #000;
    margin-right: .24rem;
  }

  .box .img_txt .p .n {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: .14rem;
    line-height: .17rem;
    color: #999999;
    margin-right: .15rem;
  }

  .box .img_txt .p .t {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: .16rem;
    line-height: .19rem;
    color: #4CA5FF;
  }
</style>